import Deepmerge from '@fastify/deepmerge';

const deepmerge = Deepmerge();
function useMergedCSS(...css) {
  return css.reduce((acc, curr) => {
    if (curr === void 0) {
      return {
        "&&": acc
      };
    }
    return {
      "&&": deepmerge(
        acc,
        Object.fromEntries(
          Object.entries(curr).filter(([, v]) => v !== void 0)
        )
      )
    };
  }, {});
}

export { useMergedCSS };
//# sourceMappingURL=hooks.mjs.map
